import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'

interface SlidersDialogProps {
  openDeleteSlider: boolean
  setOpenDeleteSlider: Dispatch<SetStateAction<boolean>>
  onDelete: () => void
}

export function SlidersDialog({ openDeleteSlider, setOpenDeleteSlider, onDelete }: SlidersDialogProps) {
  const { t } = useTranslation(['global'])

  return (
    <>
      <StyledDialog
        open={openDeleteSlider}
        onClose={() => setOpenDeleteSlider(!openDeleteSlider)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">{t('delete')} Slider</Typography>
            <Button onClick={() => setOpenDeleteSlider(!openDeleteSlider)} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ pb: 3, pt: 2 }}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item xs={12}>
              <Typography>{t('admin.slider.delete-slider-text')}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => setOpenDeleteSlider(!openDeleteSlider)}>{t('cancel')}</CancelButton>
          <DeleteButton autoFocus id="btn-handleldelete" onClick={onDelete}>
            {t('delete')}
          </DeleteButton>
        </DialogActions>
      </StyledDialog>
    </>
  )
}
